import { Skill } from '../models/Skill';

export const createAdditionalSupportSkills = (
  skillsSupportType: Skill[],
  skillsMediumAndHighAncestries: Skill[],
): Skill[] => {
  const skillsMediumAndHighAncestriesIds = new Set(skillsMediumAndHighAncestries.map(skill => skill.id));
  return skillsSupportType.filter(skill => !skillsMediumAndHighAncestriesIds.has(skill.id));
};
